import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { DrawerWorkorderTitleComponent } from '../drawers/drawer-workorder-title/drawer-workorder-title.component';
import { MTX_DRAWER_DATA, MtxDrawerRef } from '@ng-matero/extensions/drawer';
import { WorkOrderDto } from 'src/api';
import { WorkOrdersRepository } from '../workorders.repository';
import { DrawerWorkorderActionsComponent } from '../drawers/drawer-workorder-actions/drawer-workorder-actions.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-workorder-optimize',
  standalone: true,
  templateUrl: './workorder-optimize.component.html',
  styleUrls: ['./workorder-optimize.component.scss'],
  imports: [
    CommonModule,
    DrawerWorkorderTitleComponent,
    MatButtonModule,
    DrawerWorkorderActionsComponent,
    TranslateModule,
  ],
})
export class WorkorderOptimizeComponent {
  get workOrder() {
    return this.data.workOrder;
  }

  constructor(
    public drawerRef: MtxDrawerRef<WorkorderOptimizeComponent>,
    @Inject(MTX_DRAWER_DATA) public data: { workOrder: WorkOrderDto },
    public workOrderRepository: WorkOrdersRepository
  ) {}

  close() {
    this.drawerRef.dismiss();
  }

  confirm() {
    const workOrderId = this.workOrder.id;
    if (workOrderId) {
      this.workOrderRepository.optimizeWorkOrder(workOrderId);
      this.drawerRef.dismiss();
    }
  }
}
